import { Fits } from "@crt/math";
import { useCallback, useMemo } from "react";

//后续延申考虑变换情况

export function useViewBox(options) {
  var width = options.width,
    height = options.height,
    viewBox = options.viewBox;

  // Fits.contain
  var aspectRatio = useMemo(function () {
    // const contentFit = Fits.contain({
    //     width: width,
    //     height: height,
    // }, {
    //     width: viewBox.width,
    //     height: viewBox.height
    // })
    //
    // console.log(`fit.width:`, contentFit.frame.width, 'fit.height:', contentFit.frame.height);
    var fit = Fits.cover({
      width: viewBox.width,
      height: viewBox.height
    }, {
      width: width,
      height: height
    });
    return fit.scale;
    // console.log(width/viewBox.width, height/viewBox.height)
    // return Math.max( width / viewBox.width, height/ viewBox.height );
  }, [width, height, viewBox.width, viewBox.height]);
  var rx = useCallback(function (value) {
    return value * aspectRatio;
  }, [aspectRatio]);
  var ry = useCallback(function (value) {
    return value * aspectRatio;
  }, [aspectRatio]);
  return {
    rx: rx,
    ry: ry,
    aspectRatio: aspectRatio
  };
}